import { FLIGHT_DEALS_PREVIEW_QUERY_PARAM } from "@flights/constants";
import { getInternalMockUrlParams } from "./internal-mock-url-params.js";
export const FLIGHT_DEAL_USE_CASE = "FLIGHT_DEAL";
export const FLIGHT_DEAL_HIGHLIGHT_REASON = "GENIUS_DEALS_LANDING_OFFER";
export const FLIGHT_DEAL_LANDING_PAGE_PRICE_PARAM = "dealPrice";
export const FLIGHT_DEAL_LANDING_PAGE_CURRENCY_PARAM = "dealCurrency";
export const FLIGHT_DEAL_OFFER_AGE_MINUTES_PARAM = "dealAgeMinutes";
export const FLIGHT_DEAL_LANDING_PAGE_TRACKING_PARAMS = [
    FLIGHT_DEAL_LANDING_PAGE_PRICE_PARAM,
    FLIGHT_DEAL_LANDING_PAGE_CURRENCY_PARAM,
    FLIGHT_DEAL_OFFER_AGE_MINUTES_PARAM
];
export const FLIGHT_DEALS_API_QUERY_PARAMS = ["origin", "earliest_from_date", "latest_to_date"];
export const FLIGHT_DEALS_PAGE_QUERY_PARAMS = [
    ...FLIGHT_DEALS_API_QUERY_PARAMS,
    FLIGHT_DEALS_PREVIEW_QUERY_PARAM
];
export function buildDealsApiQueryString(search) {
    const pageParams = new URLSearchParams(search);
    const apiParams = new URLSearchParams();
    FLIGHT_DEALS_PAGE_QUERY_PARAMS.forEach((key) => {
        const value = pageParams.get(key);
        if (value) {
            apiParams.set(key, value);
        }
    });
    return apiParams.toString();
}
export function buildDealsPageSearch(search) {
    const params = new URLSearchParams(getInternalMockUrlParams(search));
    new URLSearchParams(buildDealsApiQueryString(search)).forEach((value, key) => {
        params.set(key, value);
    });
    const query = params.toString();
    return query ? `?${query}` : "";
}
export function getFlightDealSearchUrl(deal, originCity) {
    if (!originCity?.iata)
        return "/";
    const params = new URLSearchParams();
    params.set("type", deal.tripType);
    params.set("from", originCity.iata);
    params.set("to", deal.destinationCity.iata);
    params.set("depart", deal.departureDate);
    params.set("adults", "1");
    params.set("cabinClass", deal.cabinClass);
    params.set("offerKeyToHighlight", deal.flightOfferKey);
    params.set("use_case", FLIGHT_DEAL_USE_CASE);
    params.set("direct_flow", "1");
    params.set(FLIGHT_DEAL_LANDING_PAGE_PRICE_PARAM, String(deal.discountedPrice.units));
    params.set(FLIGHT_DEAL_LANDING_PAGE_CURRENCY_PARAM, deal.discountedPrice.currencyCode);
    if (deal.offerAgeMinutes) {
        params.set(FLIGHT_DEAL_OFFER_AGE_MINUTES_PARAM, String(deal.offerAgeMinutes));
    }
    if (deal.tripType === "ROUNDTRIP" && deal.returnDate) {
        params.set("return", deal.returnDate);
    }
    return `/flights/${originCity.iata}-${deal.destinationCity.iata}/?${params.toString()}`;
}
export function isFlightDealUseCaseSearch(search) {
    return new URLSearchParams(search).get("use_case") === FLIGHT_DEAL_USE_CASE;
}
export function removeFlightDealLandingPageTrackingParams(params) {
    FLIGHT_DEAL_LANDING_PAGE_TRACKING_PARAMS.forEach((param) => params.delete(param));
}
export function isFlightDealsLandingHighlightedOffer(flight) {
    return !!flight.highlightInfo?.highlight && flight.highlightInfo.reason === FLIGHT_DEAL_HIGHLIGHT_REASON;
}
export function shouldTrackFlightDealsHighlightedOfferClick(flight, search) {
    const searchParams = new URLSearchParams(search);
    if (searchParams.get("use_case") !== FLIGHT_DEAL_USE_CASE) {
        return false;
    }
    const highlightedOfferKey = searchParams.get("offerKeyToHighlight");
    const flightOfferKey = flight.flightKey || flight.offerKeyToHighlight;
    if (!highlightedOfferKey || flightOfferKey !== highlightedOfferKey) {
        return false;
    }
    return isFlightDealsLandingHighlightedOffer(flight);
}
